module.exports = __webpack_public_path__ + "img/log_notification_sendmagic.c6f03947.png";